import * as React from 'react';
import { FixMeLater } from '../../utils';
import { PriceBlockContext } from './PriceBlockContext';
import { TypographyPrice, TypographyPriceProps } from '../Typography';
import { TypographyPriceSize } from '../../theming';
import { PriceBlockSize } from './PriceBlock.types';

export type PriceBlockAmountProps = TypographyPriceProps;

const sizeMap: { [key in PriceBlockSize]: TypographyPriceSize } = {
    s: 's',
    m: 'm',
    l: 'l',
};

export const PriceBlockAmount: React.ForwardRefExoticComponent<
    PriceBlockAmountProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function PriceBlockAmount(
    props: PriceBlockAmountProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { size: sizeProp = 'm' } = React.useContext(PriceBlockContext);
    const size = sizeMap[sizeProp];

    return <TypographyPrice ref={ref} component="div" size={size} color="text.price" {...props} />;
});
